export default __webpack_public_path__ + "static/media/impressao.cbdf0934.jpg";